import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';

import Stepper from '../Stepper';
import { savePersonalDataByKey } from '../../../features/personalData/personalData-slice';
import userQuickAccessUserVerify from '../../../domain/userQuickAccessUserVerify';
import PageLoading from '../Loading';
import { TextFieldCPF } from '../../shared/TextFieldCPF';
import { dynamicCustomEventTracking } from '../../../lib/gtm';
import { WrapperActions } from '../ManagerStepper/styled';

type QuickAccessFormFields = {
  oyana: {
    cpf: string;
  };
};

type QuickAccessFormProps = {
  onChange: (loggedIn: boolean) => void;
  canGoBack?: boolean;
};
const QuickAccessForm = ({ onChange, canGoBack }: QuickAccessFormProps) => {
  const form = useForm<QuickAccessFormFields>();
  const { handleUserVerify, oyanaRecurrentIsLoading, signInMethodIsLoading } = userQuickAccessUserVerify();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [valid, setValid] = useState(false);
  const valueRef = useRef<string | undefined>(undefined);

  const handleNextPage = () => {
    dynamicCustomEventTracking.send({ dynamicEventName: `journey_quick_access_cpf_continue_ag` });
    handleUserVerify();
  };

  useEffect(() => {
    if (valid && valueRef.current) {
      dispatch(
        savePersonalDataByKey({
          key: 'cpf',
          value: valueRef.current
        })
      );
    }
  }, [valid, valueRef]);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          {(oyanaRecurrentIsLoading || signInMethodIsLoading) && <PageLoading />}

          <Box sx={{ mb: 4 }}>
            <Stepper separator="de" text="Dados pessoais" />
          </Box>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h3">Preencha seus dados</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sx={{ mb: 7 }}>
          <Typography variant="body6" sx={{ mb: 0.5 }}>
            CPF*
          </Typography>
          <TextFieldCPF
            form={form}
            name="oyana.cpf"
            onValidityChange={(isValid: boolean) => setValid(isValid)}
            onChange={(value: string) => {
              valueRef.current = value;
            }}
          />
        </Grid>
      </Grid>
      <WrapperActions>
        <Button
          variant="contained"
          color="secondary"
          disabled={false}
          sx={{ visibility: 'visible', padding: '12px 24px 14px 16px' }}
          onClick={() => (canGoBack ? onChange(true) : navigate(-1))}
        >
          <ArrowBackIcon />
          <Typography variant="body1" sx={{ ml: 1.5 }}>
            Voltar
          </Typography>
        </Button>

        <LoadingButton
          loading={false}
          variant="contained"
          onClick={handleNextPage}
          disabled={valueRef.current ? false : true}
          sx={{ padding: '12px 16px 14px 24px' }}
        >
          <Typography variant="body1" sx={{ mr: 1.5 }}>
            Continuar
          </Typography>
          <ArrowForwardIcon />
        </LoadingButton>
      </WrapperActions>
    </>
  );
};

export default QuickAccessForm;
